import React from 'react';
import ReactTypingEffect, { ReactTypingEffectProps } from 'react-typing-effect';
import imgDesc from 'assets/images/Marketplace/my-talent-stack.png';
import imgMob from 'assets/images/Marketplace/my-talent-stack-mob.png';
import cx from 'classnames';

import styles from './HomeFirstSection.module.scss';

const typingTextSettings: ReactTypingEffectProps = {
  text: [
    'Gain Access to New Job Requisition Opportunities',
    'Post and Fill Job Requisitions',
    'Expand Your Partner Network',
  ],
  speed: 50,
  eraseDelay: 2000,
  typingDelay: 1000,
  cursorClassName: 'typing-cursor',
};

export default function HomeFirstSection() {
  return (
    <div className={styles.firstSection}>
      <div className="container">
        <div className={styles.titleBox}>
          <div className={styles.subTitle}>More Clients, More Openings, More Placements</div>
          <div className={styles.title}>Talent Acquisition Marketplace</div>
          <div className={styles.animatedBox}>
            <span className={styles.animatedContent}>
              Our platform provides tools to:
            </span>
            <strong className="solutions-animation">
              <ReactTypingEffect {...typingTextSettings} />
            </strong>
          </div>
        </div>
        <div className={styles.imgWrapp}>
          <div className={cx(styles.lgNone, styles.imgBox)}>
            <img src={imgDesc} alt="" />
          </div>
          <div className={cx(styles.xsNone, styles.imgBox)}>
            <img src={imgMob} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
